import React from "react";
import setupIcon from '../assets/img/Icons/setup-icon.png';
import affordableCost from '../assets/img/Icons/affordable-cost.png';
import efficiancy from '../assets/img/Icons/efficiancy.png';
import productivity from '../assets/img/Icons/productivity.png';
import labill1 from './../assets/img/Illustrations/Integrated LIM-ELN home page pic .png';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
    FaRobot,
    FaFlask,
    FaClipboardCheck,
    FaGraduationCap,
    FaShieldAlt,
    FaFileAlt,
    FaArrowRight,
    FaCheckCircle,
    FaCogs
} from 'react-icons/fa';

const IntegratedSolutions = () => {
    const productsList = [
        {
            title: "Lab Iconics VMS",
            subtitle: "Validation Management System",
            badge: "AI Validation",
            badgeBg: "#e7f1ff",
            badgeColor: "#0d6efd",
            borderAccent: "#0d6efd",
            icon: <FaRobot />,
            desc: "Universal AI-powered validation platform. Execute automated 1-click validation across Lab Iconics and 3rd-party enterprise systems (SAP ERP, Empower, Veeva).",
            link: "/vms"
        },
        {
            title: "Lab Iconics IPQC",
            subtitle: "In-Process Quality Control",
            badge: "Manufacturing QC",
            badgeBg: "#f3e5f5",
            badgeColor: "#6f42c1",
            borderAccent: "#6f42c1",
            icon: <FaFlask />,
            desc: "Stage-wise manufacturing quality control. Connect lab instruments via Lab Iconics Connector for direct result fetching & automated spec compliance.",
            link: "/ipqc"
        },
        {
            title: "Lab Iconics E-Logbook",
            subtitle: "Paperless Digital Workflows",
            badge: "Digital Logbooks",
            badgeBg: "#e0f7fa",
            badgeColor: "#00838f",
            borderAccent: "#00838f",
            icon: <FaClipboardCheck />,
            desc: "Transform manual paper logbooks into 21 CFR Part 11 compliant digital workflows with dual e-signatures, audit trails & equipment status tracking.",
            link: "/elog"
        },
        {
            title: "Lab Iconics LMS",
            subtitle: "Learning Management System",
            badge: "AI Learning Engine",
            badgeBg: "#e6f4ea",
            badgeColor: "#198754",
            borderAccent: "#198754",
            icon: <FaGraduationCap />,
            desc: "Centralized AI-powered learning & competency management. Auto-generate quizzes from SOPs, track role-based training matrices & maintain audit readiness.",
            link: "/lms"
        },
        {
            title: "Lab Iconics QMS",
            subtitle: "Quality Management System",
            badge: "Quality & Compliance",
            badgeBg: "#fff3cd",
            badgeColor: "#ff9800",
            borderAccent: "#ff9800",
            icon: <FaShieldAlt />,
            desc: "Automate deviations, CAPAs, change controls, and manage complete document lifecycles with controlled approvals & versioning.",
            link: "/qms"
        },
        {
            title: "Lab Iconics T-LIMS",
            subtitle: "Testing Laboratory LIMS",
            badge: "Commercial Labs",
            badgeBg: "#e8eaf6",
            badgeColor: "#3f51b5",
            borderAccent: "#3f51b5",
            icon: <FaFileAlt />,
            desc: "Specialized LIMS for testing laboratories and contract facilities. Streamline sample lifecycles, ISO 17025 compliance & automated COA releases.",
            link: "/tlims"
        }
    ];

    return (
        <div id="lims-eln" className="integration-main py-5">
            <div className="container">
                <div className="inte-section-title text-center mb-5" data-aos="zoom-out">
                    <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 rounded-pill fw-semibold mb-2" style={{ backgroundColor: '#e7f1ff', color: '#0d6efd', fontSize: '13px', letterSpacing: '1px' }}>
                        COMPLETE PRODUCT SUITE
                    </span>
                    <h1 style={{ color: '#04346f', fontWeight: 'bold', fontSize: '2.5rem' }}>Smart Solutions for Smarter Laboratories</h1>
                    <p className="text-secondary mx-auto mt-2" style={{ maxWidth: '800px', fontSize: '16px' }}>
                        Explore our enterprise-grade lab automation and digital transformation platform designed for quality, compliance, and operational excellence.
                    </p>
                </div>

                {/* Featured Products Grid */}
                <div className="row g-4 mb-5">
                    {productsList.map((product, idx) => (
                        <div key={idx} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={50 * idx}>
                            <div className="p-4 h-100 bg-white rounded-4 shadow-sm border border-light transition-all d-flex flex-column justify-content-between" style={{ borderLeft: `5px solid ${product.borderAccent}`, transition: 'all 0.3s ease' }}>
                                <div>
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <div className="p-2.5 rounded-circle d-flex align-items-center justify-content-center" style={{ backgroundColor: product.badgeBg, color: product.badgeColor, width: '48px', height: '48px', fontSize: '22px' }}>
                                            {product.icon}
                                        </div>
                                        <span className="badge px-3 py-1.5 rounded-pill fw-semibold" style={{ backgroundColor: product.badgeBg, color: product.badgeColor, fontSize: '12px' }}>
                                            {product.badge}
                                        </span>
                                    </div>
                                    <h4 className="fw-bold mb-1" style={{ color: '#04346f', fontSize: '1.25rem' }}>{product.title}</h4>
                                    <h6 className="text-muted mb-3 fw-semibold" style={{ fontSize: '0.85rem' }}>{product.subtitle}</h6>
                                    <p className="text-secondary mb-4" style={{ fontSize: '13.5px', lineHeight: '1.6' }}>{product.desc}</p>
                                </div>
                                <div>
                                    <Nav.Link as={Link} to={product.link} className="p-0">
                                        <div className="btn btn-outline-primary w-100 rounded-pill py-2.5 fw-semibold d-flex align-items-center justify-content-center gap-2" style={{ borderColor: product.borderAccent, color: product.borderAccent, fontSize: '13.5px', transition: 'all 0.3s ease' }}>
                                            Explore Product <FaArrowRight style={{ fontSize: '11px' }} />
                                        </div>
                                    </Nav.Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Main Integrated LIMS-ELN Highlight Section */}
                <div className="inte-lims-eln mt-4">
                    <div className="int-title">
                        <h3>Integrated LIMS-ELN Platform</h3>
                    </div>
                    <div className="int-content">
                        <div className="int-content-para">
                            Enhance your lab’s efficiency with Lab Iconics LIMS-ELN. Automate workflows, streamline sample management, and accelerate report generation, enabling faster decision-making and increased productivity. Simplifies experiment documentation, enhances collaboration, ensures data integrity, and accelerates research with secure, cloud-based accessibility.
                        </div>
                        <div className="int-content-2">
                            <div className="int-content-points-div">
                                <div className="tlims-features">
                                    <div className='tlims-feature-card active inte-keyicons-items' style={{ textAlign: 'left' }}>
                                        <div className="tlims-feature-icon">
                                            <div className="icon-placeholder keyicons-items-icon">
                                                <img src={setupIcon} alt="icon" />
                                            </div>
                                        </div>
                                        <div>Automated Backup System - Ensures critical data is backed up regularly to prevent loss or corruption</div>
                                    </div>
                                    <div className='tlims-feature-card active inte-keyicons-items' style={{ textAlign: 'left' }}>
                                        <div className="tlims-feature-icon">
                                            <div className="icon-placeholder keyicons-items-icon">
                                                <img src={affordableCost} alt="icon" />
                                            </div>
                                        </div>
                                        <div>Secure Data Protection - Provides encryption, compression, and versioning for enhanced data security</div>
                                    </div>
                                    <div className='tlims-feature-card active inte-keyicons-items' style={{ textAlign: 'left' }}>
                                        <div className="tlims-feature-icon">
                                            <div className="icon-placeholder keyicons-items-icon">
                                                <img src={efficiancy} alt="icon" />
                                            </div>
                                        </div>
                                        <div>Disaster Recovery Ready - Allows seamless data restoration across locations or virtual environments</div>
                                    </div>
                                    <div className='tlims-feature-card active inte-keyicons-items' style={{ textAlign: 'left' }}>
                                        <div className="tlims-feature-icon">
                                            <div className="icon-placeholder keyicons-items-icon">
                                                <img src={productivity} alt="icon" />
                                            </div>
                                        </div>
                                        <div>Flexible Scheduling - Automates backups at daily, weekly, or monthly intervals for continuous data safety</div>
                                    </div>
                                </div>
                                <div className='learn-more-div-eln' style={{ position: 'relative', zIndex: '20', padding: '0' }}>
                                    <Nav.Link as={Link} to='/lims-eln' href='#lims-eln'>
                                        <div className='learn-more-btn' style={{ backgroundColor: '#bfd6e1' }}>
                                            <span>Explore LIMS-ELN</span>
                                            <div className="arrow arrow--right">
                                                <span></span>
                                            </div>
                                        </div>
                                    </Nav.Link>
                                </div>
                            </div>
                            <div className="sticky-feature-image-container img-two" style={{ background: 'none', zIndex: '10' }}>
                                <img src={labill1} alt="LIMS ELN Content illustration" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section: Instrument & SAP Integration Highlights */}
                <div className="int-two-sections mt-5">
                    <div className="inte-lims-qms" data-aos="fade-up" data-aos-delay="100">
                        <h3 data-aos="zoom-out">Integrated Ecosystem & Compliance</h3>
                        <div>
                            <ul>
                                <li>Seamlessly manage samples, workflows, and experimental data in one place—bridging operational efficiency with scientific documentation.</li>
                                <li>Enhance quality control by integrating LIMS with QMS & IPQC, enabling automated compliance checks, audit trails, and deviation handling.</li>
                                <li>Achieve real-time data acquisition from lab instruments directly into LIMS & IPQC, minimizing manual entry errors.</li>
                                <li>Consolidate lab operations, quality records, VMS execution logs, and instrument logs into a unified platform for total traceability.</li>
                                <li>Integrated systems streamline regulatory documentation (21 CFR Part 11, ISO, GxP, ALCOA+), enabling automated SOPs and validation workflows.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="inte-lims-instru" data-aos="fade-up" data-aos-delay="100">
                        <h3 data-aos="zoom-out">Instrument & ERP Connectivity</h3>
                        <div>
                            <ul>
                                <li>Instrument Integration (RS232, TCP/IP, USB, File-based) - Connects with lab instruments using standard protocols to automate data capture into LIMS & IPQC.</li>
                                <li>Lab Iconics Connector - Direct auto-fetching of test values from balances, verniers, and hardness testers into IPQC & LIMS.</li>
                                <li>ERP & SAP Integration - Syncs with SAP HANA (ODATA, BAPI, CDS Views) for real-time updates on sample requests, inventory, batch numbers, and test results.</li>
                                <li>End-to-End Digital Traceability - Centralizes data from instruments and business systems into one platform, ensuring full audit readiness.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntegratedSolutions;